import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "./apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);
  const [fxRate, setFxRate] = useState(0.92);
  const [currency, setCurrency] = useState("USD");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  useEffect(() => {
    api.get("/fx/usd-eur").then(({ data }) => setFxRate(data.usd_eur)).catch(() => {});
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      return { ok: true, message: data.message };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  const convert = (usd) => (currency === "EUR" ? usd * fxRate : usd);
  const fmt = (usd) => {
    const v = convert(Number(usd || 0));
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(v);
  };

  return (
    <AuthContext.Provider
      value={{ user, ready, login, register, logout, fxRate, currency, setCurrency, convert, fmt }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
